import axiosInstance from "../interceptor/tokenInterceptor";
import {rootApi} from "./config";

export const imports = async () => {
    const response = await axiosInstance.get(rootApi + '/import');
    return response.data;
};
